import Icon from '../components/Icon.vue'

Icon.register({
  hotdog: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488.6 23.4c12.9 12.9 23.4 38.3 23.4 56.6s-10.5 43.6-23.4 56.6l-352 352c-13 13.5-38.8 24.4-57.5 24.4-44.2 0-80-35.8-80-80 0-18.7 10.9-44.5 24.4-57.5l352-352c12.9-12.9 38.3-23.4 56.6-23.4s43.6 10.5 56.6 23.4zM438.6 118.6c2.6-2.6 4.7-7.7 4.7-11.3 0-8.8-7.2-16-16-16-3.7 0-8.7 2.1-11.3 4.7-12.4 12.4-21.8 14-34.7 16.2-14.4 2.5-32.3 5.6-51.9 25.1-19.6 19.6-22.7 37.5-25.1 51.9-2.2 13-3.8 22.3-16.2 34.7-12.4 12.4-21.7 14-34.7 16.2-14.4 2.5-32.3 5.5-51.9 25.1-19.6 19.6-22.7 37.5-25.2 51.9-2.2 13-3.8 22.3-16.2 34.7s-21.7 14-34.7 16.2c-14.4 2.5-32.3 5.5-51.9 25.1-2.6 2.6-4.7 7.7-4.7 11.3 0 8.8 7.2 16 16 16 3.7 0 8.7-2.1 11.3-4.7 12.4-12.4 21.8-14 34.7-16.2 14.4-2.5 32.3-5.6 51.9-25.1 19.6-19.6 22.7-37.5 25.1-51.9 2.2-13 3.8-22.3 16.2-34.7s21.8-14 34.7-16.2c14.4-2.5 32.3-5.6 51.9-25.2 19.6-19.6 22.7-37.5 25.1-51.9 2.2-13 3.8-22.3 16.2-34.7s21.8-14 34.7-16.2c14.4-2.5 32.3-5.5 51.9-25.1zM31.4 322.2l-11.6-11.5c-25-25-26.7-63.8-3.7-86.8l207.7-207.7c22.9-22.9 61.8-21.3 86.8 3.7l11.5 11.6zM480.6 189.8l11.6 11.5c25 25 26.7 63.8 3.7 86.8l-207.7 207.7c-22.9 22.9-61.8 21.3-86.8-3.7l-11.5-11.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hotdog.js
// module id = 1466
// module chunks = 0